import { observer } from "mobx-react";
import React from "react";
import ReactTooltip from "react-tooltip";
import { createGlobalStyle } from "styled-components";

import Style from "@client/utils/Style";

const GlobalStyle = createGlobalStyle`
  .reactTooltip {
    color: ${Style.palette.grayscale[4]} !important;
    background: ${Style.palette.grayscale[1]} !important;
    max-width: 192px;
    padding: 8px !important;
    box-shadow: 0 0 9px 1px rgba(32, 34, 52, 0.1);
    opacity: 1 !important;
    z-index: 999999 !important;
    transition: opacity ${Style.animations.swift} !important;
  }
  .place-right.reactTooltip:after {
    background-color: ${Style.palette.grayscale[1]} !important;
  }
`;

@observer
class Tooltip extends React.Component {
  intervalId: number | undefined;

  componentDidMount() {
    if (this.intervalId) {
      return;
    }
    this.intervalId = window.setInterval(() => {
      ReactTooltip.rebuild();
    }, 1000);
  }

  render() {
    return (
      <>
        <GlobalStyle />
        <ReactTooltip
          place="right"
          effect="solid"
          className="reactTooltip"
          html
        />
      </>
    );
  }
}

export default Tooltip;
